/**
 * Utility class for handling URL redirection.
 */
export class RedirectUtil {
  /**
   * Generates the URL to connect to the specified Identity Provider (IdP) for SAML SSO authentication.
   * @param idpToUse
   */
  public static getConnectToIdpUrl(idpToUse: string): string {
    const redirectUrl = encodeURIComponent(window.location.pathname);
    const encodedIdp = encodeURIComponent(idpToUse);
    return `/delegate/SamlSsoAuthRequestProviderServlet?operation=generateAuthRequest&redirectURL=${redirectUrl}&idpToUse=${encodedIdp}`;
  }

  /**
   * Redirects the browser to the specified URL.
   * @param url The URL to redirect to.
   */
  public static redirectTo(url: string): void {
    window.location.href = url;
  }
}
